import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Tooltip from 'components/common/tool-tip-component';
import { ReactComponent as InfoIcon } from 'icons/bulb.svg';
import { ReactComponent as CloseButton } from 'icons/close-button.svg';

const INFO_ICON_SIZE = 25;
const CLOSE_ICON_DIMENSION = '16px';
const BLOCK = 'side-by-side-info-icon';

const InfoIconComponent = ({ id, tooltip, defaultExpanded = false }) => {
  const intl = useIntl();
  const [isInitialOpen, setIsInitialOpen] = useState(defaultExpanded);
  const [isHovered, setIsHovered] = useState(false);

  const handleCloseTooltip = (e) => {
    e.stopPropagation();
    setIsInitialOpen(false);
  };

  const handleMouseEnter = () => {
    if (!isInitialOpen) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const showTooltip = isInitialOpen || isHovered;

  const getTooltipParts = () => {
    if (!tooltip) return { title: '', content: [] };
    const message = intl.formatMessage({ id: tooltip });
    const [title, contentStr] = message.split('||');
    const content = contentStr
      ? contentStr
          .trim()
          .split(/\\n|\n/)
          .filter(Boolean)
      : [];
    return { title: title?.trim() || '', content };
  };

  if (defaultExpanded) {
    const { title, content } = getTooltipParts();
    return (
      <div
        id={id}
        className={`${BLOCK}__wrapper`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <InfoIcon
          width={INFO_ICON_SIZE}
          height={INFO_ICON_SIZE}
          className={`${BLOCK}__icon`}
        />
        {showTooltip && (
          <div className={`${BLOCK}__tooltip`}>
            <div className={`${BLOCK}__tooltip-header`}>
              <span className={`${BLOCK}__tooltip-title`}>{title}</span>
              {isInitialOpen && (
                <CloseButton
                  className={`${BLOCK}__tooltip-close`}
                  onClick={handleCloseTooltip}
                  height={CLOSE_ICON_DIMENSION}
                  width={CLOSE_ICON_DIMENSION}
                />
              )}
            </div>
            {content?.length > 0 && (
              <div className={`${BLOCK}__tooltip-content`}>
                {content.map((line, index) => (
                  <div key={index} dangerouslySetInnerHTML={{ __html: line }} />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  return (
    <Tooltip text={tooltip} id={id}>
      <InfoIcon width={INFO_ICON_SIZE} height={INFO_ICON_SIZE} />
    </Tooltip>
  );
};

InfoIconComponent.propTypes = {
  /** ID for the tooltip */
  id: PropTypes.string,
  /** i18n key for tooltip text. For expanded tooltip, use format "title||content" */
  tooltip: PropTypes.string,
  /** Whether the tooltip should be expanded by default (shows title and content) */
  defaultExpanded: PropTypes.bool,
};

export default InfoIconComponent;
